import { ClockService } from "oidc-client";
import { logInfo } from "../../logger";
import axios from "axios";
import { IAppSettings } from "../configuration/appsettings";

class BetterClockService implements ClockService {
  private readonly _serviceUrl: string;
  private readonly _appSettings: IAppSettings;
  private _drift: number;
  private _serverTime: number;

  constructor(serviceUrl: string, appSettings: IAppSettings) {
    this._serviceUrl = serviceUrl;
    this._appSettings = appSettings;
  }

  _getServerTime = async (): Promise<number> => {
    logInfo("getting current time, from clock service");

    const result = await axios.get(this._serviceUrl);

    const serverTime = result.data;

    logInfo(`serverTime is ${serverTime}`);

    return serverTime;
  };

  getEpochTime = async (): Promise<number> => {
    const clientTime = Date.now() / 1000;

    if (this._appSettings.FORCE_CLIENT_TIME) {
      return Promise.resolve(clientTime);
    }

    if (!this._serverTime) {
      this._serverTime = await this._getServerTime();

      this._drift = this._serverTime - clientTime;

      logInfo(`Customer clock has ${this._drift} seconds of drift`);
    }

    return Promise.resolve(clientTime + this._drift);
  };
}

export default BetterClockService;
